export default "__VITE_ASSET__Cc$FeGpO__"